export default __webpack_public_path__ + "static/media/fastingfatburn@3x.e52441c3.jpg";